import Echo from 'laravel-echo'
import VoerroTagsInput from '@voerro/vue-tagsinput';
import {Chrome, Compact} from 'vue-color';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import draggable from 'vuedraggable'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18n from './i18n'
import axios from 'axios';
import VueMoment from 'vue-moment';
import Pusher from 'pusher-js';
import InvoiceTableComponent from './components/e-c/InvoiceTableComponent.vue';
import TicketTableComponent from './components/e-c/TicketTableComponent.vue';
import ResourceDisplayComponent from './components/e-c/ResourceDisplayComponent.vue';
import CompanyTableComponent from './components/e-c/CompanyTableComponent.vue';
import ResourceAdminTableComponent from './components/e-c/ResourceAdminTableComponent.vue';
import TicketAdminTableComponent from './components/e-c/TicketAdminTableComponent.vue';
import EstimateTableComponent from './components/e-c/EstimateTableComponent.vue';
import InvoiceAdminTableComponent from './components/e-c/InvoiceAdminTableComponent.vue';
import TypeTableComponent from './components/e-c/TypeTableComponent.vue';
import ModelsTableComponent from './components/smartcity/ModelsTableComponent.vue';
import ModelFormComponent from './components/smartcity/ModelFormComponent.vue';
import TraceabilityComponent from './components/TraceabilityComponent.vue';
import MonitoringComponent from './components/MonitoringComponent.vue';
import EquipmentsTableComponent from './components/EquipmentsTableComponent.vue';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Vue = Vue;

Vue.use(VueMoment);
Vue.use(VueI18n)

window.Pusher = Pusher;

if (process.env.MIX_ENV === 'local' || process.env.MIX_ENV === 'testing') {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_KEY,
        wsHost: window.location.hostname,
        wsPort: 8000,
        enabledTransports: ['ws', 'wss'],
    });
} else {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_KEY,
        wsHost: window.location.hostname,
        //wsPort: 443,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
    });
}

Vue.component('quillEditor', quillEditor);
Vue.component('tags-input', VoerroTagsInput);
Vue.component('chrome-picker', Chrome);
Vue.component('compact-picker', Compact);

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('vue-dropzone', vue2Dropzone);

Vue.component('draggable', draggable);
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/InvoiceTableComponent.vue -> <example-component></example-component>
 */

Vue.component('InvoiceTable', InvoiceTableComponent);
Vue.component('TicketTable', TicketTableComponent);
Vue.component('ResourceDisplay', ResourceDisplayComponent);
Vue.component('CompanyTable', CompanyTableComponent);
Vue.component('ResourceAdminTable', ResourceAdminTableComponent);
Vue.component('TicketAdminTable', TicketAdminTableComponent);
Vue.component('EstimateTable', EstimateTableComponent);
Vue.component('InvoiceAdminTable', InvoiceAdminTableComponent);
Vue.component('TypeTable', TypeTableComponent);
Vue.component('ModelsTable', ModelsTableComponent);
Vue.component('ModelForm', ModelFormComponent);
Vue.component('TraceabilityComponent', TraceabilityComponent);
Vue.component('MonitoringComponent', MonitoringComponent);
Vue.component('EquipmentsTable', EquipmentsTableComponent);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {},
    i18n
});


